// ============================================================

// CONFIG — update these three values for your store

// ============================================================

const WPL_CONFIG = {

  shopDomain: "sandcreeknursery.myshopify.com",       // your .myshopify.com domain (not the custom domain)

  storefrontAccessToken: "f4adf83ab61752741f09176c2cfdc277", // from your Custom App's Storefront API token

  apiVersion: "2025-01",

  metafieldNamespace: "product-specs",                 // check Settings > Custom data > Products > Botanical Name

  metafieldKey: "botanical_name",               // check Settings > Custom data > Products > Botanical Name

};

// ============================================================

 

async function wplFetchAllProducts() {

  const endpoint = `https://${WPL_CONFIG.shopDomain}/api/${WPL_CONFIG.apiVersion}/graphql.json`;

  let products = [];

  let cursor = null;

  let hasNextPage = true;

 

  const query = `

    query WholesaleList($cursor: String, $namespace: String!, $key: String!) {

      products(first: 100, after: $cursor, sortKey: TITLE) {

        pageInfo { hasNextPage }

        edges {

          cursor

          node {

            title

            botanicalName: metafield(namespace: $namespace, key: $key) { value }

            variants(first: 50) {

              edges {

                node {

                  id

                  title

                  availableForSale

                  quantityAvailable

                  price { amount currencyCode }

                }

              }

            }

          }

        }

      }

    }

  `;

 

  while (hasNextPage) {

    const res = await fetch(endpoint, {

      method: "POST",

      headers: {

        "Content-Type": "application/json",

        "X-Shopify-Storefront-Access-Token": WPL_CONFIG.storefrontAccessToken,

      },

      body: JSON.stringify({

        query,

        variables: {

          cursor,

          namespace: WPL_CONFIG.metafieldNamespace,

          key: WPL_CONFIG.metafieldKey,

        },

      }),

    });

 

    if (!res.ok) throw new Error(`Storefront API error: ${res.status}`);

    const json = await res.json();

    if (json.errors) throw new Error(json.errors.map((e) => e.message).join("; "));

 

    const edges = json.data.products.edges;

    products = products.concat(edges.map((e) => e.node));

    hasNextPage = json.data.products.pageInfo.hasNextPage;

    cursor = edges.length ? edges[edges.length - 1].cursor : null;

  }

 

  return products;

}

 

function wplFlattenToRows(products) {
  const rows = [];
  for (const p of products) {
    const botanical = (p.botanicalName && p.botanicalName.value) || "—";
    for (const vEdge of p.variants.edges) {
      const v = vEdge.node;
      const qty = typeof v.quantityAvailable === "number" ? v.quantityAvailable : null;
      if (qty === null || qty <= 0) continue; // only show variants with stock > 0
      rows.push({
        botanical,
        common: p.title,
        size: v.title === "Default Title" ? "—" : v.title,
        price: parseFloat(v.price.amount),
        currency: v.price.currencyCode,
        qty,
        available: v.availableForSale,
      });
    }
  }
  return rows;
}

 

function wplSortRows(rows, key, dir) {

  const sorted = [...rows].sort((a, b) => {

    let av = a[key], bv = b[key];

    if (key === "price" || key === "qty") {

      av = av ?? -Infinity; bv = bv ?? -Infinity;

      return av - bv;

    }

    return String(av).localeCompare(String(bv), undefined, { sensitivity: "base" });

  });

  return dir === "desc" ? sorted.reverse() : sorted;

}

 

function wplRenderTable(rows) {

  const tbody = document.getElementById("wpl-table-body");

  tbody.innerHTML = rows

    .map((r) => {

      const qtyDisplay = r.qty === null ? (r.available ? "Available" : "Out of stock") : r.qty;

      const qtyClass = (r.qty === 0 || r.available === false) ? "wpl-out-of-stock" : "";

      return `<tr>

        <td><em>${wplEscape(r.botanical)}</em></td>

        <td>${wplEscape(r.common)}</td>

        <td>${wplEscape(r.size)}</td>

        <td>$${r.price.toFixed(2)}</td>

        <td class="${qtyClass}">${qtyDisplay}</td>

      </tr>`;

    })

    .join("");

}

 

function wplEscape(str) {

  const div = document.createElement("div");

  div.textContent = str;

  return div.innerHTML;

}

 

function wplDownloadCSV(rows) {

  const header = ["Botanical Name", "Common Name", "Container Size", "Price", "Qty Available"];

  const lines = [header.join(",")];

  for (const r of rows) {

    const qty = r.qty === null ? (r.available ? "Available" : "Out of stock") : r.qty;

    lines.push(

      [r.botanical, r.common, r.size, r.price.toFixed(2), qty]

        .map((v) => `"${String(v).replace(/"/g, '""')}"`)

        .join(",")

    );

  }

  const blob = new Blob([lines.join("\n")], { type: "text/csv;charset=utf-8;" });

  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");

  a.href = url;

  a.download = `wholesale-price-list-${new Date().toISOString().slice(0, 10)}.csv`;

  a.click();

  URL.revokeObjectURL(url);

}

(async function wplInit() {
  const statusEl = document.getElementById("wpl-status");
  const tableEl = document.getElementById("wpl-table");
  const searchEl = document.getElementById("wpl-search");
  const updatedEl = document.getElementById("wpl-updated");

  let allRows = [];
  let currentSort = { key: "botanical", dir: "asc" };

  function applyAndRender() {
    const term = searchEl.value.trim().toLowerCase();
    let rows = allRows;
    if (term) {
      rows = rows.filter(
        (r) => r.botanical.toLowerCase().includes(term) || r.common.toLowerCase().includes(term)
      );
    }
    rows = wplSortRows(rows, currentSort.key, currentSort.dir);
    wplRenderTable(rows);
    return rows;
  }

  try {
    const products = await wplFetchAllProducts();
    allRows = wplFlattenToRows(products);
    applyAndRender();
    statusEl.style.display = "none";
    tableEl.style.display = "table";
    updatedEl.textContent = `Updated ${new Date().toLocaleString()}`;
  } catch (err) {
    statusEl.textContent = "Couldn't load availability. Please refresh, or contact us if this persists.";
    console.error("Wholesale price list error:", err);
    return;
  }

  searchEl.addEventListener("input", applyAndRender);

  document.querySelectorAll("#wpl-table th[data-sort]").forEach((th) => {
    th.addEventListener("click", () => {
      const key = th.getAttribute("data-sort");
      currentSort.dir = currentSort.key === key && currentSort.dir === "asc" ? "desc" : "asc";
      currentSort.key = key;
      applyAndRender();
    });
  });

  document.getElementById("wpl-download-csv").addEventListener("click", () => {
    wplDownloadCSV(applyAndRender());
  });
})();
